import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  background-color: white;
  margin-bottom: 12px;
  border-radius: 8px;
  ${({ showPointer }) => showPointer && 'cursor: pointer;'}
`

export const CustomImage = styled.img`
  width: 100%;
  border-radius: 8px;
`
